export default "https://cdn-static.gokick.com/assets/b944ecdade3ab4b24738bd1fcec1eea00d00fb75/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";